import { ActionType } from '../../../definitions/types/ActionType';
import { StateType } from '../../../definitions/types/StateType';
import { stateFromUrl } from '../../../utils/helpers/stateFromUrl';

export const parseReducer = (
  state: StateType,
  action: ActionType,
): StateType => {
  const payload: string = action.payload as string;
  return stateFromUrl({ url: payload, state });
};
